import { useModalContext } from "~/Provider/ModalProvider";
import {
  RightSection,
  Section,
  LeftSection,
  TextHeading,
  TextUser,
  UserImage,
  Image,
  UserComp,
  TextEmail,
  TextPhone,
  TextUserComp,
  TextVerify,
  TextUserInfo,
  LinkComp,
  ContentComp,
  CompInfo,
  CardInfo,
  CardHeading,
  CardDisc,
  TextDecoration,
  LinkText,
} from "./StyledProfile";
import { info, user, Password, edit, Succ, UserImag } from "~/images";
import { Alert, ButtonBase, Skeleton } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { GET_REQUEST } from "../../../HooksApi/useApi";
import UseGetData from "../../../HookAxios/getdata";
import { changeDataProfile } from "../Auth/features/Auth";
import { DeleteConfirmationModal } from "./deleteConfirmationModal";
import { openDeleteAcountModal } from "./store/profileSlice";
import parsePhoneNumber from "libphonenumber-js";

const Profile = () => {
  const dispatch = useDispatch();
  const token = useSelector((state) => state.Auth.userInfo.token);
  const profileData = useSelector((state) => state.Auth.userInfo.profileData);
  const { openChangedPassProfile, openverifyCode } = useModalContext();
  const data = useSelector((state) => state.Auth.userInfo.data);

  const formatPhoneNumber = (number, countryShortCode) => {
    const phoneNumber = parsePhoneNumber(number.slice(2), countryShortCode);
    return phoneNumber.formatInternational();
  };
  const {
    isLoading: getProfile,
    data: dataProfile,
    isError: isErrorProfile,
    error: errorProfile,
    refetch: refetchprofile,
  } = GET_REQUEST({
    onResault,
    queryKey: "getMyProfile",
    request: () =>
      UseGetData("get_my_profile", "", { Authorization: `Bearer ${token} ` }),
    enabled: true,
  });
  const {
    isLoading: sayingLoading,
    data: dataSaying,
    isFetching: FetchingSaying,
    isError: isErrorSaying,
    error: errorSaying,
    refetch: refetchSaying,
  } = GET_REQUEST({
    queryKey: "GetSaying",
    request: () =>
      UseGetData("get_article", "", { Authorization: `Bearer ${token} ` }),
    enabled: true,
  });
  function onResault(data) {
    dispatch(changeDataProfile(data.data.data));
  }
  return (
    <Section>
      <RightSection>
        <ContentComp>
          <UserComp>
            <UserImage>
              {data.image_path ? (
                <Image
                  src={`${process.env.REACT_APP_BASE_URL}${data.image_path}`}
                />
              ) : (
                <Image src={UserImag} alt="" />
              )}
            </UserImage>
            <TextUserComp>
              <TextUser>{data?.username}</TextUser>
              {/* <TextEmail>
                                khaledalsayed@gmail.com
                            </TextEmail> */}
              <TextUserInfo>
                {profileData?.login && (
                  <TextPhone>
                    {formatPhoneNumber(
                      profileData?.login,
                      profileData?.country_short_code
                    )}
                  </TextPhone>
                )}

                {profileData ? (
                  profileData?.is_active ? (
                    <TextVerify>
                      <img src={Succ} alt="" />
                    </TextVerify>
                  ) : null
                ) : null}
              </TextUserInfo>
            </TextUserComp>
            <LinkComp>
              <ButtonBase
                sx={{
                  background: "#0056D2",
                  width: "224px",
                  borderRadius: "4px",
                  height: "32px",
                  border: "0.5px solid #0056D2",
                  color: "white",
                }}
                component={LinkText}
                to="/edit-profile"
              >
                {/* <img src={edit} alt="" /> */}
                تعديل الحساب
              </ButtonBase>
              <ButtonBase
                sx={{
                  background: "#0056D2",
                  width: "224px",
                  borderRadius: "4px",
                  height: "32px",
                  border: "0.5px solid #0056D2",
                  color: "white",
                }}
                component={LinkText}
                onClick={openChangedPassProfile}
              >
                {/* <img src={Password} alt="" /> */}
                تغيير كلمة السر
              </ButtonBase>

              <ButtonBase
                sx={{
                  background: "#FF0000",
                  width: "224px",
                  borderRadius: "4px",
                  height: "32px",
                  border: "0.5px solid #0056D2",
                  color: "white",
                }}
                component={LinkText}
                onClick={() => dispatch(openDeleteAcountModal())}
              >
                {/* <img src={Password} alt="" /> */}
                حذف الحساب
              </ButtonBase>
            </LinkComp>
          </UserComp>
        </ContentComp>
      </RightSection>
      <LeftSection>
        {profileData?.is_active ? null : (
          <TextVerify>
            <Alert
              sx={{
                padding: "2px 15px",
                margin: "0px 20px 0 10px",
                fontSize: "12px",
              }}
              severity="error"
            >
              حسابك غير مفعل، يرجى تأكيد الرقم
            </Alert>
            {/* <img src={info} alt="" /> */}
            <ButtonBase
              sx={{
                background: "#0056D2",
                borderRadius: "4px",
                color: "#fff",
                padding: " 8px 16px",
              }}
              onClick={openverifyCode}
            >
              تأكيد
            </ButtonBase>
          </TextVerify>
        )}
        <CompInfo>
          <CardInfo>
            <CardHeading>{dataProfile?.data?.data?.points} نقطة</CardHeading>
            <CardDisc>عدد النقاط الحالية</CardDisc>
          </CardInfo>
        </CompInfo>
        {dataSaying?.data?.message ? (
          <TextHeading>{dataSaying?.data?.message}</TextHeading>
        ) : (
          <>
            <Skeleton variant="rectangular" width={"200px"} height={"40px"} />{" "}
            <br />
          </>
        )}

        {dataSaying?.data?.data?.title ? (
          <TextDecoration>
            {`“${dataSaying?.data?.data?.title}”`}
            <br />
            <br />
          </TextDecoration>
        ) : (
          <Skeleton variant="rectangular" width={"100%"} height={"100px"} />
        )}
      </LeftSection>
      <DeleteConfirmationModal />
    </Section>
  );
};

export default Profile;
